import styled from 'styled-components'
import { PROGRESS_AREA_HEIGHT } from '~/app/components/Header'
import {
  ANATOMY_COMPACT,
  anatomyCompact,
} from '~/pages/anatomy/libs/responsive'
import { anatomyRootCss } from '~/pages/anatomy/libs/styles'
import { Button } from '~/shared/components/Button'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

const CARD_BG_COLOR = '#e7e9f6'

export const Styles = {
  Root: styled.div`
    ${anatomyRootCss}
    display: flex;
    flex-direction: column;
    align-items: center;
  `,

  StyledContainer: styled(Container)`
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    margin-top: ${PROGRESS_AREA_HEIGHT}px;
    height: calc(100% - ${PROGRESS_AREA_HEIGHT}px);
  `,

  Card: styled.div`
    text-align: center;
    background-color: ${CARD_BG_COLOR};
    border-radius: 30px;
    padding: 25px 15px 50px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 16px;
  `,

  Title: styled.h1`
    font-size: 22px;
    line-height: 1.3;
    font-weight: 700;
    color: ${COLORS.PURPLE_700};

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f22};
    }
  `,

  ReviewCard: styled.div`
    background-color: ${COLORS.WHITE};
    border-radius: 15px;
    padding: 20px 10px;
    margin-bottom: 20px;
  `,

  ReviewText: styled.p`
    font-size: 14px;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.8);
    font-style: italic;
  `,

  ReviewSource: styled.p`
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
  `,

  FeaturedSection: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  `,

  FeaturedLabel: styled.p`
    font-size: 16px;
    font-weight: 700;
    color: #17202a;
  `,

  SocialImage1: styled.img`
    width: 230px;
    height: auto;
    display: block;
  `,

  SocialImage2: styled.img`
    width: 250px;
    height: auto;
    display: block;
  `,

  WorldMapContent: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 16px;
  `,

  WorldMapTitle: styled.h1`
    font-size: 26px;
    line-height: 1.2;
    font-weight: 700;
    color: ${COLORS.BLACK};
    margin-bottom: 12px;

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f24};
    }
  `,

  WorldMapReviewText: styled.p`
    font-size: 15px;
    line-height: 1.4;
    font-weight: 600;
    font-style: italic;
    color: rgba(0, 0, 0, 0.8);

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f15};
    }
  `,

  WorldMapReviewSource: styled.p`
    font-size: 15px;
    line-height: 1.4;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    margin-bottom: 24px;
  `,

  WorldMapImage: styled.img`
    width: 100%;
    height: auto;
    display: block;
  `,

  StyledButton: styled(Button)`
    width: 100%;
    margin-top: auto;
    flex-shrink: 0;
  `,
} as const
